import React from "react";
import Header from "../Header";
import Dotted from "../../../assets/svgs/Dotted";
import LeftSide from "./LeftSide";
import RightSide from "./RightSide";

const DashboardContent = ({ LeftNavRef }) => {
  let newDate = new Date().toGMTString();
  let date = newDate.split(" ")[1];
  let mongth = newDate.split(" ")[2];
  let day = newDate.split(" ")[0];
  return (
    <div className="w-full px-4 md:px-10 pb-10">
      <Header LeftNavRef={LeftNavRef} />
      <div className="relative flex justify-between items-center pb-3">
        <h3 className="text-lg hidden sm:block">Dashboard</h3>
        <div className="flex justify-between w-full sm:w-auto sm:space-x-20">
          <div className="flex items-center space-x-8 sm:space-x-16 px-5 py-1 bg-gray-50 rounded shadow-sm">
            <p className="flex flex-col items-start">
              <span className="text-2xl">{date + " " + mongth}</span>
              <small className="-mt-2">{day}</small>
            </p>
            <button>
              <Dotted />
            </button>
          </div>
          <button className="px-4 py-1 rounded bg-gradient-to-r from-pink-600 text-white to-pink-500 shadow-lg">
            Add Employee
          </button>
        </div>
      </div>

      <div className="flex flex-col xl:flex-row justify-between mt-5 xl:space-x-10">
        <LeftSide />
        <RightSide />
      </div>
    </div>
  );
};

export default DashboardContent;
